import Nav from "./Nav";
import "./About.css";
import "../App.css";
import pageTransition from "../transition";

const About = () => {
    document.title = "Xinyi | About";
    return (
        <>
            {Nav("about")}
            <main className="wrapper">
                <div className="about">
                    <p>Hi there! I am a second-year master’s student at Aalto University, majoring in Machine Learning, Data Science & Artificial Intelligence, with a minor in New Media. </p>
                    <p>I completed my bachelor's degree in Artificial Intelligence with honours in China. My research interests span the foundational aspects of Machine Intelligence. Currently, I work as a research assistant in the <a className="highlight" href="https://research.cs.aalto.fi/pml/">Probabilistic Machine Learning Group</a> and the <a className="highlight" href="https://cbl.aalto.fi/">Computational Behavior Lab</a> at Aalto University.</p>
                    <p>In my spare time, I enjoy capturing moments through photography, and some of my work is featured on <a className="highlight" href="https://unsplash.com/@ewxy">Unsplash</a>. The interplay of colour, composition, and depth of field not only provides me with new perspectives on the world but also extends my inspiration for scientific research. I am also keen on exploring the intersection of AI and Art. </p>
                    <p>Feel free to explore my projects and reach out if something catches your interest!</p>
                </div>

                {/* CONTACT INFOMATION */}
                <div className="icons-container" id="contact-container">
                    <div className="button-block">
                        <a className="contact-button" href="https://www.linkedin.com/in/xinyi-wen/">
                            <img className="icon" src="img/Linkedin.svg" alt="Linkedin icon" />
                        </a>
                    </div>
                    <div className="button-block">
                        <a className="contact-button" href="https://github.com/e-wxy">
                            <img className="icon" src="img/Github.svg" alt="GitHub icon" />
                        </a>
                    </div>
                    <div className="button-block">
                        <a className="contact-button" href="https://www.instagram.com/e.wxy/">
                            <img className="icon" src="img/Instagram.svg" alt="Instagram icon" />
                        </a>
                    </div>
                    <div className="button-block">
                        <a className="contact-button" href="mailto:xinyi.wen@aalto.fi">
                            <img className="icon" src="img/email.svg" alt="email icon" />
                        </a>
                    </div>
                </div>
            </main>

            <div className="smile">
                <p>:)</p>
            </div>

            {/* FOOTER */}
            <footer>© 2025 | Xinyi Wen</footer>
        </>

    );
};

export default pageTransition(About);
